import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {Observable} from "rxjs";
import { Buffer } from 'buffer';

@Injectable({
  providedIn: 'root'
})
export class LogosService {

  constructor(private http: HttpClient) { }

  getSupplierSystemLogoUrl(supplier_system_logo_key: string): Observable<any> {
    let encoded = Buffer.from(supplier_system_logo_key).toString('base64')
    return this.http.get(`${environment.yomaApiURL}/resources/logos/${encoded}`);
  }

  uploadLogo(uploadUrl: string, fields: any, file: File): Observable<any> {
    const formData = new FormData();

    Object.keys(fields).forEach((key) => {
      formData.append(key, fields[key]);
    });

    // formData.append("files", file);
    formData.append('file', file, file.name);

    // const headers = new HttpHeaders({
    //   contentType: "image/png"
    // });

    return this.http.post(uploadUrl, formData, {
      // headers,
      reportProgress: true,
      observe: "events"
    });
  }
}
